import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import {
motion
} from "framer-motion";

import {
  Layout,
  Menu,
  Drawer,
  Button,
  Typography,
  Badge,
  Dropdown
} from "antd";
import ParentAndStudentProfile from "./ParentAndStudentProfile";
import BioLinkProfile from "./BioLinkProfile";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  UserOutlined,
  ReadOutlined,
  DollarOutlined,
  CalendarOutlined,
  FileTextOutlined,
  NotificationOutlined,
  LogoutOutlined
} from "@ant-design/icons";
import {
  Box,
  Grid,
  Avatar,
  IconButton
} from "@mui/material";
import {
  FaUsers,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaClipboardList,
  FaGraduationCap,
  FaArrowRight,
  FaDoorOpen,
} from "react-icons/fa";
import Swal from "sweetalert2";
import api from "../api/api";
import ProfileImage from "../NewDashboard/ProfileImage";
import Notification from "../NewDashboard/Notification/Notification";
import ParentsStudentGrades from "../pages/Students/ParentsStudentGrades";
import defaultAvatar from "./maleee.jpg";
import logo from "./zpa.png";
import dashboardBanner from "./teacherss.jpg";
import {useNavigate} from "react-router-dom";
const {Header,
  Sider,
  Content
} = Layout;

const {
  Title,
  Text
} = Typography;

const ParentsDashboard =()=>{

const navigate = useNavigate();
const [collapsed,setCollapsed]=useState(false);
const [drawerOpen,setDrawerOpen]=useState(false);
const [darkMode,setDarkMode]=useState(false);
const [activePage,setActivePage]=useState("dashboard");
const [user,setUser]=useState(null);
const [loading,setLoading]=useState(true);
const [children,setChildren]=useState([]);
const [selectedChild,setSelectedChild]=useState(null);
const [showGrades,setShowGrades]=useState(false);
const [notifications,setNotifications]=useState([]);
const [unreadCount,setUnreadCount]=useState(0);
const [notificationOpen,setNotificationOpen]=useState(false);
const [clickedNotificationId,setClickedNotificationId]=useState(null);
const [loadingLogout,setLoadingLogout]=useState(false);
const [tempImage,setTempImage]=useState(null);
const [overlay,setOverlay]=useState(false);
const [isMobile,setIsMobile]=useState(
window.innerWidth < 768
);


useEffect(()=>{const resize=()=>{setIsMobile(window.innerWidth < 768);};
window.addEventListener("resize",resize);

return()=>{window.removeEventListener("resize",resize);};},[]);

const theme=useMemo(()=>({
background:
darkMode
?
"#111827"
:
"#f5f7fb",
sidebar:
darkMode
?
"#0f172a"
:
"#ffffff",


header:
darkMode
?
"#111827"
:
"#ffffff",


card:
darkMode
?
"#1e293b"
:
"#ffffff",


text:
darkMode
?
"#ffffff"
:
"#172033",


secondary:
darkMode
?
"#94a3b8"
:
"#64748b",


border:
darkMode
?
"#334155"
:
"#e5e7eb",


primary:
"#800000"


}),[darkMode]);





const token =
localStorage.getItem(
"access"
);





const fetchUserProfile=async()=>{


try{


const response=
await api.get(
"user-profile/"
);


setUser(
response.data
);


}
catch(error){


console.error(
"Profile error",
error
);


}
finally{


setLoading(false);


}


};





const refreshUser=async()=>{


try{


const response=
await api.get(
"/user-profile/",
{

headers:{

Authorization:
`Bearer ${token}`

}

}

);


setUser(
response.data
);


setTempImage(null);


}
catch(error){


console.error(
"Refresh profile error",
error
);


Swal.fire(
"Error",
"Failed to load profile",
"error"
);


}


};





const fetchChildren=async()=>{


try{


const response=
await api.get(
"/admissions/my-linked-students/",
{

headers:{

Authorization:
`Bearer ${token}`

}

}

);


setChildren(
response.data
);


}
catch(error){


console.error(
"Children error",
error
);


}


};





const fetchNotifications=async()=>{


try{


const response=
await api.get(
"api/users/notifications/",
{

headers:{

Authorization:
`Bearer ${token}`

}

}

);



const sorted=
[...response.data]
.sort(
(a,b)=>
new Date(b.created_at)
-
new Date(a.created_at)
);



setNotifications(
sorted
);



setUnreadCount(
response.data.filter(
item=>!item.is_read
).length
);



}
catch(error){


console.error(
"Notification error",
error
);


}


};





useEffect(()=>{


fetchUserProfile();

fetchChildren();

fetchNotifications();

refreshUser();


},[]);






const handleImageChange=async(e)=>{


const file=
e.target.files[0];


if(!file)
return;



const formData=
new FormData();


formData.append(
"profile_image",
file
);



setTempImage(
URL.createObjectURL(file)
);


setOverlay(true);



try{


await api.put(
"/user-profile/",
formData,
{

headers:{

Authorization:
`Bearer ${token}`,

"Content-Type":
"multipart/form-data"

}

}

);



Swal.fire(
"Success",
"Profile image updated!",
"success"
);



setOverlay(false);


refreshUser();


}
catch(error){


setOverlay(false);


setTempImage(null);



Swal.fire(
"Failed",
"Could not update image",
"error"
);


}


};






const markAsRead=async(id)=>{


try{


await api.post(
`api/users/notifications/${id}/mark_as_read/`,
{

is_read:true

},

{

headers:{

Authorization:
`Bearer ${token}`

}

}

);



setNotifications(
prev=>
prev.map(
item=>
item.id===id
?
{
...item,
is_read:true
}
:
item
)

);



setUnreadCount(
prev=>
Math.max(
0,
prev-1
)

);


}
catch(error){


console.error(
error
);


}


};






const handleNotificationClick=async(id)=>{


setClickedNotificationId(id);


await markAsRead(id);



setTimeout(()=>{


setClickedNotificationId(null);


},500);



};







const handleLogout=async()=>{


setLoadingLogout(true);



try{


await api.post(
"api/logout/",
{}
);



localStorage.removeItem(
"access"
);



navigate(
"/login"
);



}
catch(error){


console.error(
error
);



localStorage.removeItem(
"access"
);



navigate(
"/login"
);



}
finally{


setLoadingLogout(false);


}


};






const menuItems=[


{

key:"dashboard",

icon:<DashboardOutlined/>,

label:"Dashboard"

},


{

key:"assignments",

icon:<FileTextOutlined/>,

label:"Assignments"

}



];



const childMenuItems=children.map(
child=>({

key:`child_${child.id}`,

icon:<UserOutlined/>,

label:child.full_name

})

);




const fullMenu=[

...menuItems,

{
type:"divider"
},

{
type:"group",
label:"My Children",
children: childMenuItems
}

];




const handleMenuClick=({key})=>{


if(key.startsWith("child_")){


const id=
key.split("_")[1];


const child=
children.find(
item=>
item.id.toString()===id
);



setSelectedChild(
child
);


setShowGrades(
false
);


}



setActivePage(
key
);



if(isMobile)
setDrawerOpen(false);



};



const sidebar=(

<div
style={{
height:"100vh",
display:"flex",
flexDirection:"column",
background:theme.sidebar
}}
>


<div
style={{
height:85,
display:"flex",
alignItems:"center",
padding:"0 18px",
gap:14,
borderBottom:`1px solid ${theme.border}`,
flexShrink:0
}}
>


<img
src={logo}
alt="logo"
style={{
width:48,
height:48,
borderRadius:14,
objectFit:"cover",
boxShadow:"0 8px 20px rgba(128,0,0,.25)"
}}
/>


{
!collapsed &&

<div
style={{
overflow:"hidden"
}}
>

<Title
level={5}
style={{
margin:0,
fontSize:16,
color:theme.text,
fontWeight:800,
lineHeight:1.2
}}
>

{/* Jana L. Williams
Education Foundation */}
Salvation In Christ School System

</Title>


<Text
style={{
fontSize:12,
color:theme.secondary
}}
>

School Management Portal

</Text>


</div>

}


</div>





{
!collapsed &&

<div
style={{
padding:"20px 15px 10px",
flexShrink:0
}}
>


<div
style={{
background:
darkMode
?
"linear-gradient(135deg,#1e293b,#0f172a)"
:
"linear-gradient(135deg,#fff,#f8fafc)",
borderRadius:22,
padding:18,
textAlign:"center",
border:`1px solid ${theme.border}`,
boxShadow:"0 12px 30px rgba(0,0,0,.08)"
}}
>

{
!collapsed &&

<div
style={{
padding:"20px 15px 10px",
flexShrink:0
}}
>

<ParentAndStudentProfile

user={user}

refreshUser={refreshUser}

tempImage={tempImage}

setTempImage={setTempImage}

theme={theme}

darkMode={darkMode}

/>

</div>

}

</div>



</div>

}







<div
style={{
flex:1,
overflowY:"auto",
padding:"10px 12px"
}}
>


<Menu
mode="inline"
items={fullMenu}
selectedKeys={[activePage]}
inlineCollapsed={collapsed}
onClick={handleMenuClick}
theme={
darkMode
?
"dark"
:
"light"
}
style={{
border:"none",
background:"transparent",
fontWeight:600
}}
/>



</div>





<div
style={{
height:60,
display:"flex",
alignItems:"center",
padding:"0 18px",
borderTop:`1px solid ${theme.border}`,
flexShrink:0
}}
>


<Text
style={{
fontSize:12,
color:theme.secondary
}}
>


© 2026 Salvation In Christ School System

</Text>


</div>



</div>

);






const mobileSidebar=(

<div
style={{
height:"100%",
background:theme.sidebar
}}
>

{sidebar}


</div>

);






const sidebarWidth=
collapsed
?
75
:
270;






const drawerContent=(

<Drawer

open={drawerOpen}

width={280}

placement="left"

onClose={()=>setDrawerOpen(false)}

bodyStyle={{
padding:0,
background:theme.sidebar
}}

>

{mobileSidebar}


</Drawer>

);



return(

<div
style={{
position:"fixed",
top:0,
left:0,
right:0,
bottom:0,
background:theme.background,
overflow:"hidden"
}}
>


<Layout
style={{
height:"100vh",
background:theme.background
}}
>



{
!isMobile &&

<Sider
width={sidebarWidth}
collapsed={collapsed}
collapsedWidth={75}
style={{
height:"100vh",
position:"fixed",
left:0,
top:0,
bottom:0,
background:theme.sidebar,
borderRight:`1px solid ${theme.border}`,
zIndex:20,
overflow:"hidden"
}}
>


{sidebar}


</Sider>

}



{
isMobile &&
drawerContent

}





<Layout
style={{
marginLeft:
isMobile
?
0
:
sidebarWidth,
height:"100vh",
background:theme.background
}}
>





<Header
style={{
height:isMobile?65:75,
padding:isMobile?"0 12px":"0 25px",
display:"flex",
alignItems:"center",
justifyContent:"space-between",
background:theme.header,
borderBottom:`1px solid ${theme.border}`,
position:"sticky",
top:0,
zIndex:10,
boxShadow:"0 4px 20px rgba(0,0,0,.05)"
}}
>





<div
style={{
display:"flex",
alignItems:"center",
gap:15
}}
>



<Button
shape="circle"
size="large"
icon={
isMobile
?
<MenuUnfoldOutlined/>
:
collapsed
?
<MenuUnfoldOutlined/>
:
<MenuFoldOutlined/>
}
onClick={()=>{


if(isMobile){

setDrawerOpen(true);

}
else{

setCollapsed(
!collapsed
);

}


}}
/>





{
!isMobile &&

<div>

<Typography
style={{
fontSize:22,
fontWeight:800,
color:theme.text
}}
>

Parent Dashboard

</Typography>



<Typography
style={{
fontSize:12,
color:theme.secondary
}}
>

School Management System

</Typography>


</div>

}




</div>







<div
style={{
display:"flex",
alignItems:"center",
gap:isMobile?8:18
}}
>






<Button
shape="circle"
onClick={()=>setDarkMode(!darkMode)}
style={{
background:
darkMode
?
"#334155"
:
"#f1f5f9",
border:"none"
}}
>


{
darkMode
?
"☀️"
:
"🌙"
}


</Button>







<Dropdown
open={notificationOpen}
onOpenChange={setNotificationOpen}
placement="bottomRight"

dropdownRender={()=>(
<div
style={{
width:330,
background:theme.card,
borderRadius:18,
padding:15,
boxShadow:"0 15px 40px rgba(0,0,0,.15)",
border:`1px solid ${theme.border}`,
maxHeight:350,
overflowY:"auto"
}}
>


<Typography
style={{
fontWeight:800,
fontSize:16,
color:theme.text,
marginBottom:10,
textAlign:"center"
}}
>

Notifications

</Typography>



{
notifications.length>0
?

notifications.map(
(item)=>(


<div
key={item.id}
onClick={()=>
handleNotificationClick(item.id)
}
style={{
padding:"12px 10px",
borderRadius:12,
cursor:"pointer",
marginBottom:8,
background:
item.is_read
?
"transparent"
:
darkMode
?
"#334155"
:
"#f8fafc",
border:
`1px solid ${theme.border}`
}}
>



<Typography
style={{
fontWeight:
item.is_read
?
500
:
800,
fontSize:13,
color:theme.text
}}
>

{item.message}

</Typography>




<Text
style={{
fontSize:11,
color:theme.secondary
}}
>

{
new Date(
item.created_at
)
.toLocaleString()
}

</Text>



</div>


)

)

:

<Typography
style={{
textAlign:"center",
color:theme.secondary
}}
>

No notifications

</Typography>


}



</div>
)}

>


<Badge
count={unreadCount}
offset={[0,0]}
>


<Button
shape="circle"
icon={
<NotificationOutlined/>
}
/>


</Badge>


</Dropdown>
















<Button
danger
shape={
isMobile
?
"circle"
:
"default"
}
icon={
<LogoutOutlined/>
}
loading={loadingLogout}
onClick={handleLogout}
style={{

display:"flex",
alignItems:"center",
gap:8,
fontWeight:700

}}
>


{
!isMobile &&
"Logout"
}


</Button>






</div>






</Header>







<Content
style={{
padding:isMobile?12:25,
background:theme.background,
height:"calc(100vh - 75px)",
overflowY:"auto"
}}
>


<motion.div

initial={{
opacity:0,
y:20
}}

animate={{
opacity:1,
y:0
}}

transition={{
duration:.4
}}

>




{
activePage==="dashboard" &&

<Box
sx={{
display:"flex",
flexDirection:"column",
gap:4
}}
>

<Box>
  <BioLinkProfile
  user={user}
  dashboardBanner={dashboardBanner}
 />
</Box>







<Grid
container
spacing={3}
>



<Grid
item
xs={12}
sm={6}
lg={3}
>



<motion.div
whileHover={{
y:-8
}}
>



<Box
sx={{
background:theme.card,
borderRadius:4,
padding:3,
display:"flex",
alignItems:"center",
gap:2,
boxShadow:"0 15px 35px rgba(0,0,0,.08)",
border:`1px solid ${theme.border}`
}}
>



<Box
sx={{
width:60,
height:60,
borderRadius:"50%",
background:
"linear-gradient(135deg,#800000,#b91c1c)",
display:"flex",
alignItems:"center",
justifyContent:"center",
color:"#fff",
fontSize:28
}}
>

<FaUsers/>

</Box>



<Box>

<Typography
sx={{
fontSize:13,
color:theme.secondary
}}
>

My Children

</Typography>



<Typography
sx={{
fontSize:28,
fontWeight:900,
color:theme.text
}}
>

{children.length}

</Typography>


</Box>



</Box>



</motion.div>


</Grid>









<Grid
item
xs={12}
sm={6}
lg={3}
>



<motion.div
whileHover={{
y:-8
}}
>



<Box
sx={{
background:theme.card,
borderRadius:4,
padding:3,
display:"flex",
alignItems:"center",
gap:2,
boxShadow:"0 15px 35px rgba(0,0,0,.08)",
border:`1px solid ${theme.border}`
}}
>



<Box
sx={{
width:60,
height:60,
borderRadius:"50%",
background:
"linear-gradient(135deg,#2563eb,#60a5fa)",
display:"flex",
alignItems:"center",
justifyContent:"center",
color:"#fff",
fontSize:28
}}
>

<FaCalendarAlt/>

</Box>



<Box>

<Typography
sx={{
fontSize:13,
color:theme.secondary
}}
>

Recent Payment

</Typography>



<Typography
sx={{
fontSize:28,
fontWeight:900,
color:theme.text
}}
>

0%

</Typography>


</Box>



</Box>



</motion.div>


</Grid>








<Grid
item
xs={12}
sm={6}
lg={3}
>



<motion.div
whileHover={{
y:-8
}}
>



<Box
sx={{
background:theme.card,
borderRadius:4,
padding:3,
display:"flex",
alignItems:"center",
gap:2,
boxShadow:"0 15px 35px rgba(0,0,0,.08)",
border:`1px solid ${theme.border}`
}}
>



<Box
sx={{
width:60,
height:60,
borderRadius:"50%",
background:
"linear-gradient(135deg,#16a34a,#4ade80)",
display:"flex",
alignItems:"center",
justifyContent:"center",
color:"#fff",
fontSize:28
}}
>

<FaMoneyBillWave/>

</Box>



<Box>

<Typography
sx={{
fontSize:13,
color:theme.secondary
}}
>

Fees Balance

</Typography>



<Typography
sx={{
fontSize:28,
fontWeight:900,
color:theme.text
}}
>

$0

</Typography>


</Box>



</Box>



</motion.div>


</Grid>








<Grid
item
xs={12}
sm={6}
lg={3}
>



<motion.div
whileHover={{
y:-8
}}
>



<Box
sx={{
background:theme.card,
borderRadius:4,
padding:3,
display:"flex",
alignItems:"center",
gap:2,
boxShadow:"0 15px 35px rgba(0,0,0,.08)",
border:`1px solid ${theme.border}`
}}
>



<Box
sx={{
width:60,
height:60,
borderRadius:"50%",
background:
"linear-gradient(135deg,#f59e0b,#fbbf24)",
display:"flex",
alignItems:"center",
justifyContent:"center",
color:"#fff",
fontSize:28
}}
>

<FaClipboardList/>

</Box>



<Box>

<Typography
sx={{
fontSize:13,
color:theme.secondary
}}
>

Events Notifications

</Typography>



<Typography
sx={{
fontSize:28,
fontWeight:900,
color:theme.text
}}
>

{unreadCount}

</Typography>


</Box>



</Box>



</motion.div>


</Grid>



</Grid>









<Box
sx={{
background:theme.card,
borderRadius:5,
padding:{
xs:2,
md:4
},
boxShadow:"0 15px 35px rgba(0,0,0,.08)",
border:`1px solid ${theme.border}`
}}
>



<Typography
sx={{
fontWeight:900,
fontSize:22,
color:theme.text,
mb:3
}}
>

Parent Analytics

</Typography>





<Grid
container
spacing={3}
>



<Grid
item
xs={12}
md={4}
>



<Box
sx={{
height:200,
borderRadius:4,
background:
darkMode
?
"linear-gradient(135deg,#1e293b,#334155)"
:
"linear-gradient(135deg,#fff,#f1f5f9)",
display:"flex",
alignItems:"center",
justifyContent:"center",
flexDirection:"column"
}}
>


<FaGraduationCap
style={{
fontSize:50,
color:"#800000"
}}
/>


<Typography
sx={{
mt:2,
fontWeight:800,
color:theme.text
}}
>

Academic Progress

</Typography>


</Box>


</Grid>







<Grid
item
xs={12}
md={4}
>



<Box
sx={{
height:200,
borderRadius:4,
background:
darkMode
?
"linear-gradient(135deg,#1e293b,#334155)"
:
"linear-gradient(135deg,#fff,#f1f5f9)",
display:"flex",
alignItems:"center",
justifyContent:"center",
flexDirection:"column"
}}
>


<ReadOutlined
style={{
fontSize:50,
color:"#2563eb"
}}
/>


<Typography
sx={{
mt:2,
fontWeight:800,
color:theme.text
}}
>

Assignments

</Typography>


</Box>


</Grid>







<Grid
item
xs={12}
md={4}
>



<Box
sx={{
height:200,
borderRadius:4,
background:
darkMode
?
"linear-gradient(135deg,#1e293b,#334155)"
:
"linear-gradient(135deg,#fff,#f1f5f9)",
display:"flex",
alignItems:"center",
justifyContent:"center",
flexDirection:"column"
}}
>


<CalendarOutlined
style={{
fontSize:50,
color:"#16a34a"
}}
/>


<Typography
sx={{
mt:2,
fontWeight:800,
color:theme.text
}}
>

School Events

</Typography>


</Box>


</Grid>



</Grid>




</Box>




</Box>

}




{
activePage.startsWith("child_") && selectedChild &&

<Box
sx={{
background:theme.card,
borderRadius:5,
padding:{
xs:2,
md:4
},
border:`1px solid ${theme.border}`,
boxShadow:"0 20px 40px rgba(0,0,0,.08)"
}}
>



<Box
sx={{
display:"flex",
flexDirection:{
xs:"column",
md:"row"
},
gap:4,
alignItems:"center",
mb:4
}}
>



<Avatar
src={
selectedChild.student_admission_image
||
defaultAvatar
}
sx={{
width:150,
height:150,
border:"5px solid #fdc057",
boxShadow:"0 15px 35px rgba(128,0,0,.25)"
}}
/>




<Box
sx={{
textAlign:{
xs:"center",
md:"left"
}
}}
>


<Typography
sx={{
fontSize:32,
fontWeight:900,
color:theme.text
}}
>

{selectedChild.full_name}

</Typography>



<Typography
sx={{
color:theme.secondary,
fontSize:15
}}
>

Student Profile

</Typography>



<Typography
sx={{
mt:1,
display:"inline-block",
padding:"6px 18px",
borderRadius:20,
background:"#800000",
color:"#fff",
fontWeight:700
}}
>

{selectedChild.grade_class_name || "N/A"}

</Typography>



<Box
sx={{
mt:2
}}
>

<Button
variant="contained"
onClick={()=>setShowGrades(true)}
sx={{
borderRadius:20,
background:
"linear-gradient(135deg,#800000,#b91c1c)",
fontWeight:700
}}
>

View Grades

</Button>


</Box>



</Box>



</Box>






{
showGrades ?

<ParentsStudentGrades

selectedChild={selectedChild}

onBack={()=>
setShowGrades(false)
}

/>

:

<Grid
container
spacing={3}
>






<Grid
item
xs={12}
md={6}
>


<Box
sx={{
padding:3,
borderRadius:4,
background:
darkMode
?
"#1e293b"
:
"#f8fafc",
border:`1px solid ${theme.border}`
}}
>


<Typography
sx={{
fontWeight:900,
fontSize:18,
color:theme.text,
mb:2
}}
>

Attendance Summary

</Typography>



<Grid
container
spacing={2}
>



<Grid
item
xs={4}
>

<Box
sx={{
textAlign:"center",
padding:2,
borderRadius:3,
background:"#dcfce7"
}}
>


<Typography
sx={{
fontSize:12
}}
>

Present

</Typography>



<Typography
sx={{
fontSize:25,
fontWeight:900,
color:"#166534"
}}
>

{
selectedChild.total_present || 0
}

</Typography>


</Box>


</Grid>







<Grid
item
xs={4}
>

<Box
sx={{
textAlign:"center",
padding:2,
borderRadius:3,
background:"#fee2e2"
}}
>


<Typography
sx={{
fontSize:12
}}
>

Absent

</Typography>



<Typography
sx={{
fontSize:25,
fontWeight:900,
color:"#991b1b"
}}
>

{
selectedChild.total_absent || 0
}

</Typography>


</Box>


</Grid>








<Grid
item
xs={4}
>

<Box
sx={{
textAlign:"center",
padding:2,
borderRadius:3,
background:"#fef3c7"
}}
>


<Typography
sx={{
fontSize:12
}}
>

Late

</Typography>



<Typography
sx={{
fontSize:25,
fontWeight:900,
color:"#92400e"
}}
>

{
selectedChild.total_late || 0
}

</Typography>


</Box>


</Grid>



</Grid>


</Box>


</Grid>









<Grid
item
xs={12}
md={6}
>


<Box
sx={{
padding:3,
borderRadius:4,
background:
darkMode
?
"#1e293b"
:
"#f8fafc",
border:`1px solid ${theme.border}`
}}
>


<Typography
sx={{
fontWeight:900,
fontSize:18,
color:theme.text,
mb:2
}}
>

Fees Information

</Typography>



<Box
sx={{
display:"flex",
justifyContent:"space-between",
mb:1
}}
>


<Text
style={{
color:theme.secondary
}}
>

Total Fee

</Text>



<Text
style={{
fontWeight:800,
color:theme.text
}}
>

${selectedChild.total_fee || 0}

</Text>


</Box>





<Box
sx={{
display:"flex",
justifyContent:"space-between",
mb:1
}}
>


<Text
style={{
color:theme.secondary
}}
>

Amount Paid

</Text>



<Text
style={{
fontWeight:800,
color:theme.text
}}
>

${selectedChild.amount_paid || 0}

</Text>


</Box>





<Box
sx={{
display:"flex",
justifyContent:"space-between"
}}
>


<Text
style={{
color:theme.secondary
}}
>

Balance

</Text>



<Text
style={{
fontWeight:800,
color:"#800000"
}}
>

${selectedChild.balance_fee || 0}

</Text>


</Box>



</Box>


</Grid>









<Grid
item
xs={12}
>


<Box
sx={{
padding:3,
borderRadius:4,
background:
darkMode
?
"#1e293b"
:
"#f8fafc",
border:`1px solid ${theme.border}`
}}
>



<Typography
sx={{
fontSize:20,
fontWeight:900,
color:theme.text,
mb:2
}}
>

Complaints

</Typography>





{
selectedChild.complaints &&
selectedChild.complaints.length>0

?

selectedChild.complaints.map(
(item)=>(


<Box
key={item.id}
sx={{
padding:2,
borderRadius:3,
mb:2,
background:theme.card,
border:`1px solid ${theme.border}`
}}
>



<Typography
sx={{
fontWeight:800,
color:theme.text
}}
>

{item.title}

</Typography>




<Typography
sx={{
color:theme.secondary,
fontSize:14
}}
>

{item.description}

</Typography>



</Box>



)

)

:

<Typography
sx={{
color:theme.secondary
}}
>

No complaints found

</Typography>



}



</Box>



</Grid>






</Grid>

}




</Box>


}







</motion.div>


</Content>

</Layout>


</Layout>



</div>

);


};


export default ParentsDashboard;